export class RegistrationModificationOptions {
  public constructor() {
    this.PaymentAdjustmentTypeId = 0;
    this.InvoiceAdjustmentTypeId = 0;
    this.UnappliedPaymentPaymentypeId = 0;
    this.CreateUnappliedPayments = false;
    this.RefundCreditCardPayments = false;
    this.Notes = '';
    this.DoNotModifyInvoice = false;
  }

  public PaymentAdjustmentTypeId: number;
  public InvoiceAdjustmentTypeId: number;
  public UnappliedPaymentPaymentypeId: number;
  public Notes: string;
  public CreateUnappliedPayments: boolean;
  public RefundCreditCardPayments: boolean;
  public DoNotModifyInvoice: boolean;
}
